import styled, { keyframes } from 'styled-components';
import bounceInRight from 'react-animations/lib/bounce-in-right';
import bounceOutDown from 'react-animations/lib/bounce-out-right';

const bounceInAnimation = keyframes`${bounceInRight}`;
const bounceOutAnimation = keyframes`${bounceOutDown}`;

export const Avatar = styled.img`
  border-radius: 100%;
  height: 75px;
  object-fit: cover;
  width: 75px;
`;
Avatar.displayName = 'Avatar';

export const Container = styled.section`
  animation: 1s ${({ show }) => (show ? bounceInAnimation : bounceOutAnimation)};
  display: flex;
  font-family: 'Roboto', sans-serif;
  font-size: 42px;
  width: 100%;
`;
Container.displayName = 'Container';

export const QuestionContainer = styled.div`
  background: #efefef;
  color: #000;
  flex: 1;
  margin-left: 8px;
  min-width: 130px;
  padding: 16px;
`;
QuestionContainer.displayName = 'QuestionContainer';

export const QuestionText = styled.p`
  color: #000;
  font-size: 42px;
  font-weight: 600;
  margin: 0;
  white-space: break-spaces;
`;
QuestionText.displayName = 'QuestionText';

export const UserNameText = styled.p`
  color: #333;
  font-size: 25px;
  font-weight: 300;
  margin: 0 0 16px;
`;
UserNameText.displayName = 'UserNameText';
